import type { GetTweetFeedType } from './getTweetFeedType';

export type GetTweetFeedParams = {
page?: number;
size?: number;
/**
 * Feed type
 */
type?: GetTweetFeedType;
/**
 * User ID for USER type feeds
 */
userId?: string;
/**
 * Hashtag for HASHTAG type feeds
 */
hashtag?: string;
};
